import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, Mail, Phone, X } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function WhatsAppButton() {
  const {
    t
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  return <div className="fixed bottom-6 right-6 z-50 flex items-end justify-end" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)} data-id="element-328">
      <AnimatePresence data-id="element-329">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="absolute bottom-20 right-0 mb-2 w-[320px] bg-white rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] border border-gray-100 p-6" data-id="element-330">
            {/* Close button */}
            <button onClick={() => setIsOpen(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 rounded-full p-1.5 transition-colors" data-id="element-331">
              <X className="w-4 h-4" data-id="element-332" />
            </button>

            {/* Floating Logo Circle on the left edge */}
            <div className="absolute -left-6 top-8 w-12 h-12 bg-bodyon-teal rounded-full flex items-center justify-center shadow-lg border-4 border-white" data-id="element-333">
              <img src="https://cdn.magicpatterns.com/uploads/on22uAviriffrmYHXbYAJ8/ISO_ERGOCENTER_1.svg" alt="Body On Isotype" className="w-6 h-6 brightness-0 invert" data-id="element-334" />
            </div>

            <div className="pl-4" data-id="element-335">
              {/* Logo Typography */}
              <div className="flex items-center mb-2" data-id="element-336">
                <span className="font-heading font-bold text-2xl tracking-wide bg-gradient-to-r from-[#2B7A8F] via-[#30BBA8] to-[#5CD4C2] bg-clip-text text-transparent" data-id="element-337">
                  Body • On
                </span>
              </div>

              <h4 className="text-sm font-medium text-gray-500 mb-6" data-id="element-338">
                ¿En qué podemos ayudarte?
              </h4>

              <div className="space-y-4 mb-6" data-id="element-339">
                <a href="mailto:contacto@bodyon.com.mx" className="flex items-center gap-3 text-gray-700 hover:text-bodyon-teal transition-colors text-sm font-medium" data-id="element-340">
                  <Mail className="w-4 h-4 text-gray-400" data-id="element-341" />
                  contacto@bodyon.com.mx
                </a>
                <a href="tel:+525512345678" className="flex items-center gap-3 text-gray-700 hover:text-bodyon-teal transition-colors text-sm font-medium" data-id="element-342">
                  <Phone className="w-4 h-4 text-gray-400" data-id="element-343" />
                  +52 (56) 2320 5056
                </a>
              </div>

              <div className="space-y-3" data-id="element-344">
                <a href="https://wa.me/?text=Hola,%20me%20interesa%20agendar%20una%20Evaluación%20Postural" target="_blank" rel="noopener noreferrer" className="block w-full text-center py-3 px-4 rounded-2xl border-2 border-gray-100 text-bodyon-teal-dark font-bold text-sm hover:border-bodyon-teal hover:bg-bodyon-surface transition-all" data-id="element-345">
                  Evaluación Postural
                </a>
                <a href="https://wa.me/?text=Hola,%20me%20interesa%20agendar%20una%20Consulta%20de%20Estética%20Regenerativa" target="_blank" rel="noopener noreferrer" className="block w-full text-center py-3 px-4 rounded-2xl bg-bodyon-teal text-white font-bold text-sm hover:bg-bodyon-teal-dark transition-all shadow-md" data-id="element-346">
                  Estética Regenerativa
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Glassmorphism Square Button */}
      <motion.button initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 1,
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="relative w-14 h-14 bg-white/80 backdrop-blur-xl border border-white rounded-2xl flex items-center justify-center shadow-[0_8px_32px_rgba(0,0,0,0.12)] hover:shadow-[0_8px_32px_rgba(43,107,127,0.2)] hover:bg-white transition-all duration-300 group" data-id="element-347">
        <MessageCircle className="w-6 h-6 text-bodyon-teal-dark group-hover:scale-110 transition-transform duration-300" data-id="element-348" />
        {/* Subtle indicator dot */}
        <span className="absolute top-3 right-3 w-2.5 h-2.5 bg-bodyon-teal rounded-full animate-pulse border-2 border-white" data-id="element-349"></span>
      </motion.button>
    </div>;
}